import React from 'react'

const GameButton = ctx => {
  const { action, setGlobalError, text, submitted, setSubmitted, isFullWidth } =  ctx
  const submit = async (e) => {
    e.preventDefault()
    if(!submitted) {
      setSubmitted(true)
      try {
        await action()
      } catch (er) {
        setGlobalError(er)
      }
      setSubmitted(false)
    }
  }
  const cssClasses = isFullWidth ? "is-pulled-right button is-link is-large is-fullwidth" : "is-pulled-right button is-link is-large"

  return <span>
    <a disabled={submitted} className={submitted ? `${cssClasses} loading` : cssClasses} onClick={submit}>{text}</a>
    <style jsx>{`
      .loading {
        opacity: 0.8;
      }
    `}</style>
    </span>
}

export default GameButton
